import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'semantic-ui-css/semantic.min.css';

// REDUX
import { Provider } from 'react-redux'
import { allReducer } from './reducers/index'


ReactDOM.render(
    <Provider store={allReducer}>
        <App />
    </Provider>
,document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js